import { ModelFieldInputType } from '@shared/modelField/modelField';
import { optionalString } from '@shared/utils/transform';
export const frontWallFields = (model, { translate }) => {
    var _a, _b;
    return [
        {
            label: translate('model.external_damage.front_wall_floor_count'),
            value: model.frontWallFloorCount,
            displayedValue: (_b = optionalString((_a = model.frontWallFloorCount) === null || _a === void 0 ? void 0 : _a.toString())) !== null && _b !== void 0 ? _b : undefined,
            editable: {
                input: {
                    type: ModelFieldInputType.Number,
                    min: 1,
                    max: 3,
                },
                modelKey: 'frontWallFloorCount',
            },
        },
        {
            label: translate('model.external_damage.front_wall_wideness'),
            value: model.frontWallWideness,
            displayedValue: model.frontWallWideness != null ? `${model.frontWallWideness / 1000} m` : undefined,
            editable: {
                input: {
                    type: ModelFieldInputType.Number,
                    min: 0,
                },
                modelKey: 'frontWallWideness',
            },
        },
    ];
};
